import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import api from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import PolicyRulesPanel from '../../components/ui/PolicyRulesPanel';

// Uyum profilinin atama kuralları (AKM POC §6.3) — "kime, hangi tarihten itibaren". Profilin kendisi
// listedeki çekmecede düzenlenir. Yazma kapısı SM (PolicyRuleKinds.ModuleFor("complianceProfile")).
//
// Tek kaydırma: sayfa kabı sabit yükseklikte ve taşmaz; kayan yalnız kural tablosunun satırlarıdır.
const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

const Content = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-top: 8px;
`;

export default function ComplianceProfileDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { canWrite } = useAuth();
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    // api.js GET'te reddetmez: sinyal res.data.status.
    api.get(`/v1/shift-compliance-profiles/${id}`).then((res) => {
      if (res?.data?.status === true) setProfile(res.data.data);
    });
  }, [id]);

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('complianceProfile.title'), path: '/compliance-profiles' },
          { label: profile?.name || '...' },
        ]} />
      </StickyHeader>

      <Content>
        <PolicyRulesPanel
          kind="complianceProfile"
          policyId={id}
          title={t('complianceProfile.assignmentRules')}
          canWrite={canWrite('SM')}
        />
      </Content>
    </PageContainer>
  );
}
